import { useMutation } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import { ads } from "../Services/api";

export default function useAdsMutation() {
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (payload) =>
      ads
        .post("/", payload, {
          headers: { Authorization: `Bearer ${accessToken}` },
        })
        .then((res) => res.data),
  });
}
